import { PolicyTargetStatus, policyConfig } from "shared";

import { fieldIsValid } from "../../../../../lib/helper";
import { Toggle } from "../../../../../../common/Atoms/Toggle";

import { IFieldProps } from "./fieldProps";

const config = policyConfig[`target_status`];

export function LateFeeTargetStatus({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  const value = policyFormData.target_status === PolicyTargetStatus.ISSUED;

  function onChange(e: { value: unknown; name: string }) {
    const newValue = e.value ? PolicyTargetStatus.ISSUED : null;

    handleChange({
      name: `target_status`,
      value: newValue,
    });
  }

  return (
    <Toggle
      label={ config.label }
      description={ `When enabled, use the issue date instead of due date for the grace period & calculations.` }
      checked={ value }
      onChange={ onChange }
      invalid={ fieldIsValid(`target_status`, invalids) }
      name={ `target_status` }
    />
  );
}
